// ON-407: URL helpers for the web RSVP flow on /share/event/:id.
//
// `?rsvp=confirm` marks a return to the event page after an auth round trip
// (Google OAuth, or the signup confirmation email): with a session present the
// page shows the confirm-RSVP prompt. Every other share-link param (lang, ref,
// src, ...) rides along so attribution survives the round trip.

const RSVP_PARAM = 'rsvp'
const RSVP_CONFIRM = 'confirm'

// Left behind by an OAuth callback; carrying them into a new redirectTo makes
// Supabase append a second `code` to the callback URL.
const OAUTH_NOISE = ['code', 'error', 'error_code', 'error_description', 'state']

function params(search: string): URLSearchParams {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
}

function serialise(p: URLSearchParams): string {
  const qs = p.toString()
  return qs ? `?${qs}` : ''
}

/** Absolute URL to come back to after auth: the event page with `rsvp=confirm`. */
export function buildRsvpReturnUrl(origin: string, pathname: string, search: string): string {
  const p = params(search)
  for (const key of OAUTH_NOISE) p.delete(key)
  p.delete(RSVP_PARAM)
  p.append(RSVP_PARAM, RSVP_CONFIRM)
  return `${origin}${pathname}${serialise(p)}`
}

export function hasRsvpConfirm(search: string): boolean {
  return params(search).get(RSVP_PARAM) === RSVP_CONFIRM
}

/** `search` without the rsvp marker ('' when nothing is left). */
export function stripRsvpConfirm(search: string): string {
  const p = params(search)
  p.delete(RSVP_PARAM)
  return serialise(p)
}

/** ON-411 share attribution tags, for analytics. Empty values are dropped. */
export function trackingParams(search: string): { ref?: string; src?: string } {
  const p = params(search)
  const out: { ref?: string; src?: string } = {}
  const ref = p.get('ref')
  const src = p.get('src')
  if (ref) out.ref = ref
  if (src) out.src = src
  return out
}
